import React, { useEffect, useState } from 'react'
import InfoModal from './Info/InfoModal'


const Posts = ({ posts, loading }) => {

  //Update the page without reloading
    useEffect(() => {

    },[])
  

    if(loading){
        return <h2>Loading...</h2>
    }


  return (
    <div className='row g-3 justify-content-center'>
           {posts.map(post => (
            <div id='player-card' class="card d-flex flex-wrap col-lg-2 m-3 pt-2 style={{width:18 rem}}" key={post.id}>
                  <img src={post.photo}  width="150px" className="mx-auto img-fluid" alt="player"/>
                                <div class="card-body">
                                        <h5 class="card-title">{post.name}</h5>
                                        <p class="card-text ">{post.number == null ? "-" : post.number}</p> 
                                        {/* <p class="card-text">{post.position}</p> */}
                                        <div>
                                          <InfoModal post={post}/>
                                        </div>
                                </div>
            </div>
                            
           ))}
               
    </div>
  )
}

export default Posts